import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Autoplay } from "swiper/modules";
import { assets } from "../assets/assets";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

function OfferCarasol() {
  const navigate = useNavigate();
  
  // Updated offers array with real product IDs
  const offers = [
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Eye-of-Eternal-Watcher_ftuql7.webp",
      alt: "Exclusive Offer 1",
      id: "686e168657b1fede02373fee"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Aztec-Sun_clpqsd.webp",
      alt: "Exclusive Offer 2",
      id: "67cfd777c3b5436eba94b2a8"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Astitva-Warrior-Mantra_j8lgkd.webp",
      alt: "Exclusive Offer 3",
      id: "6878dfdc941e491b956649e9"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Mahakaal-Divine_evwbxd.webp",
      alt: "Exclusive Offer 4",
      id: "677fa2eea9d45cae937f64a5"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Eye-of-Eternal-Watcher_ftuql7.webp",
      alt: "Exclusive Offer 5",
      id: "686e168657b1fede02373fee"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Aztec-Sun_clpqsd.webp",
      alt: "Exclusive Offer 6",
      id: "67cfd777c3b5436eba94b2a8"
    },
    {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Astitva-Warrior-Mantra_j8lgkd.webp",
      alt: "Exclusive Offer 3",
      id: "6878dfdc941e491b956649e9"
    },
     {
      src: "https://res.cloudinary.com/dypkxqirq/image/upload/v1757420658/Mahakaal-Divine_evwbxd.webp",
      alt: "Exclusive Offer 4",
      id: "677fa2eea9d45cae937f64a5"
    },
  ];

  // Navigate to dynamic product page
  const handleClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Offer Carousel - Exclusive Deals for You</title>
        <meta
          name="description"
          content="Discover exclusive offers and deals on a wide range of products. Explore our Offer Carousel to grab the best deals now!"
        />
        <meta
          name="keywords"
          content="offers, exclusive deals, discounts, product carousel, online shopping, limited-time offers"
        />
      </Helmet>

      <div className="w-full">
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false
          }}
          breakpoints={{
            640: { slidesPerView: 1.5, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 0 },
            1024: { slidesPerView: 4, spaceBetween: 0 }
          }}
        >
          {offers.map((offer) => (
            <SwiperSlide key={offer.id}>
              <div
                onClick={() => handleClick(offer.id)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={offer.src}
                  alt={offer.alt}
                  className="h-100% w-full object-cover sm:h-[100%] sm:w-[100%] sm:object-cover md:h-[28rem] md:w-full lg:h-[32rem] lg:w-full"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}

export default OfferCarasol;
